import { render, staticRenderFns } from "./WhatsappIncomingTariff.vue?vue&type=template&id=74922dc4&"
import script from "./WhatsappIncomingTariff.vue?vue&type=script&lang=ts&"
export * from "./WhatsappIncomingTariff.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports